export const PARTNERS_LOAD_REQUEST = 'PARTNERS_LOAD_REQUEST';
export const PARTNERS_LOAD_SUCCESS = 'PARTNERS_LOAD_SUCCESS';
export const PARTNERS_LOAD_FAILURE = 'PARTNERS_LOAD_FAILURE';
export const PARTNERS_ADD_PARTNER = 'PARTNERS_ADD_PARTNER';
export const PARTNERS_UPDATE_PARTNER = 'PARTNERS_UPDATE_PARTNER';
